import React, { useState } from 'react';
import { Media } from '../../../models/Media/Media';
import { ButtonPrimary } from '../Button/ButtonPrimary';
import { Dropzone, DropzonePreview } from '../../../dropzone';

interface MediaUploadProps {
  onUploadComplete: (uploadedMedia: Media[]) => void;
}

export const MediaUpload: React.FC<MediaUploadProps> = ({
  onUploadComplete
}) => {
  const [files, setFiles] = useState<File[]>([]);
  const [isUploading, setIsUploading] = useState(false);

  // This function will be passed to your Dropzone component
  const handleSelectFiles = (selectedFiles: File[]) => {
    setFiles((prev) => [...prev, ...selectedFiles]);
  };

  // This function will be passed to your DropzonePreview component
  const handleRemoveFile = (indexToRemove: number) => {
    setFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  // This function calls the API to upload the files
  const handleUpload = async () => {
    if (files.length === 0) return;
    setIsUploading(true);
    try {
      const uploadedMedia = await Media.upload(files);
      // Notify the parent component that the upload is finished
      onUploadComplete(uploadedMedia);
    } catch (error) {
      console.error('Upload failed:', error);
      // You can add a user-facing error message here
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div>
      <Dropzone onSelectFiles={handleSelectFiles} maxFiles={10} />

      {files.length > 0 && (
        <div style={{ marginTop: '1rem' }}>
          <h4>Selected Files:</h4>
          <DropzonePreview files={files} onRemove={handleRemoveFile} />
          <div style={{ marginTop: '1rem' }}>
            <ButtonPrimary onClick={handleUpload} disabled={isUploading}>
              {isUploading ? 'Uploading...' : `Upload ${files.length} File(s)`}
            </ButtonPrimary>
          </div>
        </div>
      )}
    </div>
  );
};
